import React, {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import * as Auth from '../../../store/ducks/auth.duck'
import Spinner from 'react-bootstrap/Spinner'
import {useNavigate, useLocation} from 'react-router-dom'
import {login} from '../core/_requests'

export function EmailAuth() {
  //

  // console.log('In Email Auth')

  const [loading, setLoading] = useState(false)
  const [runOnce, setRunOnce] = useState(false)
  const ssoStatus = useSelector((state) => state.auth.SSOStatus)
  let navigate = useNavigate()

  const enableLoading = () => {
    setLoading(true)
  }

  const disableLoading = () => {
    setLoading(false)
    navigate('/home')
  }

  const searchParams = useLocation().search
  const mk = new URLSearchParams(searchParams).get('mk_bf')
  const rn = new URLSearchParams(searchParams).get('rn_bf')

  const username = 'email'
  const password = mk + ':' + rn

  const dispatch = useDispatch()

  useEffect(() => {
    //
    // Some Commentary about this
    // Essentially when someone creates a submits a form, a processing window appears and disappears once the form is processed
    //
    if (ssoStatus) {
      checkFormStatus(ssoStatus)
    }
  })

  function checkFormStatus(ssoStatus) {
    if (ssoStatus) {
      // Ok processed finished successfully - we have logged into VH
      // console.log('Process finished successfully');
      // Turn off loading screen
      setLoading(false)
      // Reset SSO status
      dispatch(Auth.actions.ssoclear())
      // Back to the main menu
      navigate('/home')
    }
  }

  async function attemptLogin() {
    try {
      dispatch(Auth.actions.ssoclear())
      setRunOnce(true)
      enableLoading()
      const {data} = await login(username, password)
      dispatch(Auth.actions.login(data))
      await dispatch(Auth.actions.getVHLogin(data.member_key, data.token, data.email))
    } catch (err) {
      disableLoading()
    }
  }

  if (!loading && !runOnce) {
    // Prevent the login if not all parameters are present - there is a googlebot pinging this without a membership number
    if (mk && rn) {
      attemptLogin()
    } else {
      setRunOnce(true)
      navigate('/home')
    }
  }

  return (
    <>
      {loading ? (
        <span className='indicator-progress' style={{display: 'block'}}>
          Please wait while we log you in... <Spinner animation='border' className='bc-sync-spinner' size='sm' variant='light' />
        </span>
      ) : null}
    </>
  )
  //
  //
}
